module.exports = __webpack_public_path__ + "static/28-64a1894ab0799acdd8ba7a7c27abf727.jpg";